import axios from "axios";

export default {
    namespaced: true,
    state: {
        collection: {
            data: [],
            meta: {
                current_page: 1,
                last_page: null,
                per_page: 15,
                total: 0
            }
        },
        cities: [],
        neighborhoods: [],
        client: {
            person: {
                complement: {}
            },
            portals: [],
            import: []
        }
    },
    mutations: {},
    actions: {
        async getCities({state}, params) {
            return await axios.get('/admin/city-region/cities', {params}).then(response => {  
                state.cities = response.data;
                return response.data;
            })
        },
        async getAll({state}, params) {
            return await axios.get('/admin/city-region/cities', {params}).then(response => {  
                state.collection = response.data;
                return response.data;
            })
        }
    },
    getters: {}
}